import { UIHeading4 } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './Features.css';
import { getFeaturesList } from './utils';
import { IDailyRentOfferForMobileSite } from '../../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

interface IFeaturesProps {
  features: IDailyRentOfferForMobileSite['features'];
  className?: string;
}

export const Features = ({ features, className }: IFeaturesProps) => {
  const featuresList = getFeaturesList(features);

  if (!featuresList.length) {
    return null;
  }

  return (
    <span className={cn(styles['root'], className)}>
      {featuresList.map((name, idx) => (
        <React.Fragment key={`feature-${idx}`}>
          <UIHeading4 data-name="Feature" display="inline">
            {name}
          </UIHeading4>
          {idx < featuresList.length - 1 && <span className={styles['separator']}>•</span>}
        </React.Fragment>
      ))}
    </span>
  );
};
